import { render, staticRenderFns } from "./SearchLayout.vue?vue&type=template&id=939525ce&scoped=true&"
import script from "./SearchLayout.vue?vue&type=script&lang=js&"
export * from "./SearchLayout.vue?vue&type=script&lang=js&"
import style0 from "./SearchLayout.vue?vue&type=style&index=0&id=939525ce&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "939525ce",
  null
  
)

export default component.exports